import React, { useEffect, useState } from "react";
import { PropertiesCard } from "../../../../components/Cards/PropertiesCard";
import { CustomTag } from "../../../../components/Tags/CustomTag";
import "./PartDetailsDialog.css";
import { getPartExpandedInfo } from "../../Services/PartsService";

const mapRawData = (part, item, additionalPartInfo) => [
  {
    title: "General",
    data: [
      {
        PN: part.partNumber,
        "PN Description": `${part.name} (${part.description})`,
        SN: item.SN ?? "N/A",
        Batch: item.Batch,
        GRN: item.Batch,
        "Vendor Lot": additionalPartInfo?.vendorLot ?? "N/A",
      },
      {
        "PN Category": part.categoryName,
        "PN Sub Category": part.subCategoryName,
        "Unit of measurement": item.uomName,
        Condition: "New",
        ATA: `${part.aviationPart?.atachapterName ?? "00"}-${
          part.aviationPart?.atasectionName ?? "00"
        }-${part.aviationPart?.ataparagraphName ?? "00"}`,
      },
    ],
  },
  {
    title: "Certification",
    data: [
      {
        "Certificate Type": additionalPartInfo?.certificateType ?? "N/A",
        "Certificate Number": additionalPartInfo?.certificateNumber ?? "N/A",
        "Certificate File": additionalPartInfo?.certificateFile ?? "N/A",
      },
      {
        "Last Tag Printed": "TAG-5312",
        "Latest RI By": "CERT-2024-5678",
        "Latest RI Date": "2024-10-31",
      },
    ],
  },
  {
    title: "Accounting",
    data: [
      {
        Owner: part.manufacturerName,
        Company: part.manufacturerName,
        "Inventory GL": "INV-GKL1231",
      },
      ...(item.type === "part"
        ? [
            {
              "Unit Cost": `${"$1,500 USD".toLocaleString("en-US")}`,
            },
          ]
        : [
            {
              "Unit Cost": `${"$1,500 USD".toLocaleString("en-US")}`,
              "Average Cost": `${"$1,500 USD".toLocaleString("en-US")}`,
            },
          ]),
    ],
  },
];

export const PartDetailsDialog = ({
  onClose,
  partDetail,
  item,
  additionalPartInfo,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(mapRawData(partDetail, item, additionalPartInfo));
  }, [partDetail]);

  return (
    <div className="part-details-dialog-component">
      <div className="header">
        <div className="title-container">
          <b>General</b>
          <CustomTag tag={item.type} />
        </div>
        <button className="outlined icon" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <div className="sections">
        {data.map((section, index) => (
          <React.Fragment key={index}>
            <hr></hr>
            <div className="section">
              <b>{section.title}</b>
              <div className="section-info">
                {section.data.map((data, i) => (
                  <PropertiesCard key={i} object={data} singleCard />
                ))}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
